(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lab-tested"] && !Shopify.designMode) return;
  try {
    
  if (!window.itGirlLabDetailsReady) {
    window.itGirlLabDetailsReady = true;
    document.addEventListener('click', function(event) {
      var close = event.target.closest('[data-lab-close]');
      if (!close) return;
      var details = close.closest('details');
      details.open = false;
      details.querySelector('summary').focus({ preventScroll: true });
      details.querySelector('summary').scrollIntoView({ block: 'nearest', behavior: 'instant' });
    });
    document.addEventListener('toggle', function(event) {
      var details = event.target;
      if (!details.matches || !details.matches('.lab__disclosure[open]')) return;
      details.closest('.lab__stats').querySelectorAll('.lab__disclosure[open]').forEach(function(other) {
        if (other !== details) other.open = false;
      });
    }, true);
    document.addEventListener('shopify:block:select', function(event) {
      var details = event.target.querySelector('.lab__disclosure');
      if (details) details.open = true;
    });
  }

  } catch(e) { console.error(e); }
})();
})();
